import { useGetAppStatuses } from '../../hooks/useGetAppStatus';
import { NotificationStatusView } from './NotificationStatusView';
import { jsx as _jsx } from "react/jsx-runtime";
export const NotificationStatus = ({
  appId,
  type = 'tag',
  ribbonProps,
  underline
}) => {
  const {
    data,
    loading
  } = useGetAppStatuses({
    appId,
    categories: ['NOTIFICATION']
  });
  if (loading || !(data !== null && data !== void 0 && data.length)) {
    return null;
  }
  return /*#__PURE__*/_jsx(NotificationStatusView, {
    statusesList: data,
    type: type,
    ribbonProps: ribbonProps,
    underline: underline
  });
};